import * as types from "../constants/actionConstants";
import {trackSavePromise} from "../utilities/saveInFlightManager";

export const TEMPLATE_SAVE_FULFILLED = "fulfilled";
export const TEMPLATE_SAVE_REJECTED = "rejected";

export function templateSaveSucceeded(result) {
    return result?.status === TEMPLATE_SAVE_FULFILLED;
}

export async function runTrackedTemplateSave(dispatch, operation) {
    dispatch({type: types.TEMPLATE_SAVE_START});

    try {
        const value = await trackSavePromise(Promise.resolve().then(operation));
        return {status: TEMPLATE_SAVE_FULFILLED, value};
    }
    catch (reason) {
        return {status: TEMPLATE_SAVE_REJECTED, reason};
    }
    finally {
        dispatch({type: types.TEMPLATE_SAVE_END});
    }
}
